import { Tooltip } from "flowbite-react";
export default Tooltip;
